import React from "react";
import { useSelector } from "react-redux";
import WishList from "../components/WishList";

export default function Wish() {
  const wishItems = useSelector((state) => state.wishList);

  return (
    <div className="cart-container">
      <h2>Items in Your Wish list</h2>
      <div className="cart-items-container">
        <div className="cart-header cart-item-container">
          <div className="cart-item">Item</div>
          <div className="item-price">Price</div>
        </div>
        {wishItems.map(
          ({ productId, title, rating, price, imageUrl }) => (
            <WishList
              key={productId}
              productId={productId}
              title={title}
              price={price}
              imageUrl={imageUrl}
              rating={rating}
            />
          )
        )}
      </div>
    </div>
  );
}
